import React from "react";
import "./SuccessPopup.css"; // reuse same styling

const ErrorPopup = ({ title, message, onClose, buttonLabel = "Close" }) => {
  return (
    <div className="success-popup-overlay">
      <div className="success-popup">
        <h2 style={{ color: "#c62828" }}>{title}</h2>
        <p>{message}</p>
        <button onClick={onClose}>{buttonLabel}</button>
      </div>
    </div>
  );
};

export default ErrorPopup;